import React from 'react'

import styles from './styles.module.css'

export const LocalLegalInformation = ({legalInformationToView, companyName, imageURL}) => {
  const {name, rut, legalRepName, legalRepRut, address, phone, email} = legalInformationToView
  return (
    <>
      <h2>
        <img src={imageURL} alt="Logo" width="26" className={styles.logoLocal} />
        {companyName}
      </h2>
      <br />
      <h2>Información legal</h2>
      <br />
      <div className={styles.blockLegalInformation}>
        <div className={styles.leftColumn}>
          <p>Nombre razón social</p>
          <p>Rut</p>
          <p>Nombre Representante Legal</p>
          <p>Rut Representante Legal</p>
          <p>Dirección</p>
          <p>Teléfono</p>
          <p>Correo Electronico</p>
        </div>
        <div className={styles.rightColumn}>
          <p>{name}</p>
          <p>{rut}</p>
          <p>{legalRepName}</p>
          <p>{legalRepRut}</p>
          <p>{address}</p>
          <p>{phone}</p>
          <p>{email}</p>
        </div>
      </div>
    </>
  )
}
